<template>
<v-card style="margin-bottom:5px;padding:5px;display:flex">
    <div class="pa-1">
        <img src="/static/images/user-placeholder.png" class="round" style="border:solid 1px #eee;width:40px;height:40px"/>
    </div>
    <div class="pa-1">
        {{contact | fullName}}
    </div>
</v-card>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        contact: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ContactCard.vue?0f0e98aa